<template>
    <div class="app">
        <div class="conditionArea">
            <a-divider orientation="left">查询条件</a-divider>
            <a-form-model labelAlign="left"  :label-col="labelCol" :wrapper-col="wrapperCol" >
                <a-form-model-item label="项目">
                    <a-select
                        mode="multiple"
                        style="width: 100%"
                        placeholder="请选择"
                        :allowClear="true"
                        show-search option-filter-prop="children"
                        v-model="condition.projects"
                    >
                        <a-select-option v-for="i in projects" :key="i.value">
                        {{ i.value + '[' + i.text + ']' }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="人员">
                    <a-select
                        mode="multiple"
                        style="width: 100%"
                        placeholder="请选择"
                        :allowClear="true"
                        show-search option-filter-prop="children"
                        v-model="condition.users"
                    >
                        <a-select-option v-for="i in users" :key="i.value">
                        {{ i.value + '[' + i.text + ']' }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="日期">
                    <a-range-picker 
                        :placeholder="['开始日期','结束日期']" 
                        v-model="condition.dates">
                        <!-- <template slot="renderExtraFooter">
                            extra footer
                        </template> -->
                    </a-range-picker>
                </a-form-model-item>
                <a-form-model-item label="状态">
                    <a-checkbox-group v-model="condition.states" :options="states" />
                </a-form-model-item>
                <a-form-model-item >
                    <template v-if="loading">
                        <a-spin />
                    </template>
                    <template v-else>
                        <a-button type="primary" @click="query()">查询</a-button>
                        <a-button style="margin-left: 10px" type="primary" @click="export1">导出</a-button>
                        <a-button style="margin-left: 10px" type="primary" @click="exportScripting">导出Scriping Excel</a-button>
                        <a-button style="margin-left: 10px" @click="resetCondition()">重置</a-button>
                    </template>
                </a-form-model-item>
            </a-form-model>
        </div>
        <div class="dataArea">
            <vxe-grid 
                border
                resizable
                stripe
                highlight-current-row
                show-overflow
                show-header-overflow
                height="auto"
                header-align="center"
                align="center"
                :columns="columns" :data="records">
                <template v-slot:date="{ row, column }">
                    
                    <template v-if="row.isSum">
                        {{row.sumDetails[column.property]}}
                        <!-- <template v-if="columnIndex == 2">
                            {{row.duration}}
                        </template> -->
                    </template>
                    <template v-else>
                        <div v-for="item in row.details[column.property]" :key="item.id">
                            <a-popover title="备注">
                                <template slot="content">
                                    {{item.content}}
                                </template>
                                <a-button type="link">{{item.duration}}</a-button>
                            </a-popover>
                            <a-icon v-if="item.state == 1" type="check-circle" theme="twoTone" two-tone-color="#52c41a" style="font-size:16px" />
                            <a-popover v-else-if="item.state == -1" title="拒绝原因">
                                <template slot="content">
                                    {{item.approvalContent}}
                                </template>
                                <a-icon type="close-circle" theme="twoTone" two-tone-color="#eb2f96" style="font-size:16px; cursor:pointer;" />
                            </a-popover>
                            <a-icon v-else type="pause-circle" theme="twoTone" two-tone-color="#D3D3D3" style="font-size:16px" />
                        </div>
                    </template>
                </template>
            </vxe-grid>
        </div>
    </div>
</template>
<script>
export default {
  data () {
      return { 
        labelCol: { span: 24 },
        wrapperCol: { span: 24 },
        columns: [],
        records: [],
        condition: {
            projects: [],
            users: [],
            dates: [],
            states: []
        },
        projects: [],
        users:[],
        states:[{
            label: 'Approve',
            value: 1
        },{
            label: 'Reject',
            value: -1
        },{
            label: 'Unhandled',
            value: 0
        }],
        loading: false,
      }
  },
  created() {
    //获取所有项目
    this.$axios.get('/api/Working/GetAllProject').then(d => {
        this.projects = d.data;
    });
    //获取所有研发人员
    this.$axios.get('/api/Working/GetAllUser').then(d => {
        this.users = d.data;
    });
  },
  methods: {
    generateColumns(startDate,endDate) {
        let date = new Date(startDate.getTime())
        
        this.columns = [{
            field: 'userCode',
            title: '人员号',
            width: '120px',
        },{
            field: 'userName',
            title: '人员',
            width: '170px',
        },{
            field: 'deptName',
            title: '部门',
            width: '170px',
        },{
            field: 'netWork',
            title: 'NetWork',
            minWidth: '90px',
        },{
            field: 'projectCode',
            title: 'NetPlan',
            minWidth: '90px',
        },{
            field: 'projectName',
            title: '项目名称',
            minWidth: '150px',
        }]
        while(date <= endDate){
            this.columns.push({
                field: this.$moment(date).format("MM-DD"),
                title: this.$moment(date).format("MM/DD"),
                width: '100px',
                slots: { default: 'date'}
            });
            date.setDate(date.getDate() + 1)
        }
    },
    export1(){
        if(this.condition.dates.length == 0){
            this.$message.error('请选择日期范围');
            return;
        }
        let startDate = this.condition.dates[0].toDate()
        let endDate = this.condition.dates[1].toDate()
        if(this.$moment(endDate).diff(this.$moment(startDate),'day') > 31){
            this.$message.error('日期跨度不能超过一个月（31天）');
            return;
        }
        startDate.setHours(0,0,0,0)
        endDate.setHours(0,0,0,0)
        
        let data = {
            projectCodes: this.condition.projects,
            userCodes: this.condition.users,
            states: this.condition.states,
            startDate: this.$moment(startDate).format("YYYY-MM-DD"),
            endDate: this.$moment(endDate).format("YYYY-MM-DD"),
        }
        let jsonStr = JSON.stringify(data)
        let a = document.createElement('a')
        a.href = process.env.VUE_APP_INTERFACE + '/api/Working/ExportWorkingMessageData?conditionStr=' + encodeURIComponent(jsonStr)
        a.click()
    },
    exportScripting(){
        if(this.condition.dates.length == 0){
            this.$message.error('请选择日期范围');
            return;
        }
        let startDate = this.condition.dates[0].toDate()
        let endDate = this.condition.dates[1].toDate()
        if(this.$moment(endDate).diff(this.$moment(startDate),'day') > 31){
            this.$message.error('日期跨度不能超过一个月（31天）');
            return;
        }
        startDate.setHours(0,0,0,0)
        endDate.setHours(0,0,0,0)
        
        let data = {
            projectCodes: this.condition.projects,
            userCodes: this.condition.users,
            states: this.condition.states,
            startDate: this.$moment(startDate).format("YYYY-MM-DD"),
            endDate: this.$moment(endDate).format("YYYY-MM-DD"),
        }
        let jsonStr = JSON.stringify(data)
        let a = document.createElement('a')
        a.href = process.env.VUE_APP_INTERFACE + '/api/Working/ExportForScripting?conditionStr=' + encodeURIComponent(jsonStr)
        a.click()
    },
    query(){
        if(this.condition.dates.length == 0){
            this.$message.error('请选择日期范围');
            return;
        }
        let startDate = this.condition.dates[0].toDate()
        let endDate = this.condition.dates[1].toDate()
        if(this.$moment(endDate).diff(this.$moment(startDate),'day') > 31){
            this.$message.error('日期跨度不能超过一个月（31天）');
            return;
        }
        startDate.setHours(0,0,0,0)
        endDate.setHours(0,0,0,0)
        this.generateColumns(startDate,endDate)

        let data = {
            projectCodes: this.condition.projects,
            userCodes: this.condition.users,
            states: this.condition.states,
            startDate: this.$moment(startDate).format("YYYY-MM-DD"),
            endDate: this.$moment(endDate).format("YYYY-MM-DD"),
        }
        
        this.loading = true
        this.$axios.post('/api/Working/QueryWorkingMessageData', data).then(res => { 
            this.loading = false
            this.records = res.data
        });
        // this.records = [{
        //     userName: 'A001',
        //     projectName: 'SDfasdf',
        //     details: {'05-31':[{
        //     id: 1,
        //     duration: 9.5,
        //     content: 'test',
        //     state: 1
        //     }],
        //     '06-03':[{
        //     id: 2,
        //     duration: 9.5,
        //     content: 'test1',
        //     state: 1
        //     },{
        //     id: 3,
        //     duration: 9.5,
        //     content: 'test1aaaaaa aaaaaaaa aaa aaaaaaaaaaa',
        //     state: 0
        //     },{
        //     id: 4,
        //     duration: 9.5,
        //     content: '这就是PandaVPN -2021最受欢迎的VPN工具. 在继续之前，请回答几个有关VPN的问题。',
        //     state: -1,
        //     approvalContent: '艾达大师傅'
        //     }]
        //     }
        // },{
        //     userName: 'A001(合计)',
        //     projectName: 'Approve',
        //     isSum: true,
        //     duration: 12

        // },{
        //     userName: '',
        //     projectName: 'Reject',
        //     isSum: true,
        //     duration: 12

        // },{
        //     userName: '',
        //     projectName: 'Total',
        //     isSum: true,
        //     duration: 25

        // }];
    }
  }
}
</script>
<style scoped lang="scss">
.app {
    height: 100%;
    > .conditionArea {
        height: 100%;
        width: 330px !important;
        float: left;
        // background-color: red;
        padding: 5px;
        overflow:auto
    }
    > .dataArea {
        height: 100%;
        margin-left: 330px;
        width: calc(100% - 330px);
        overflow-x: auto;
    }
}
</style>